<template>
    <div class="question-index">
        <div class="question-title center">
            <h1>Q&A</h1>
        </div>
        <section>
            <div class="know-more center">
                <div class="develop">
                    <h2>Develop</h2>
                    <ul>
                        <li>
                            <h4><i></i>Sensoro Class: How does iBeacon realize positioning?</h4>
                            <div>
                                There are lighting, acceleration and temperature sensors. Your smart phone can acquire various types of sensed data without manually connecting to BLE.
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="FAQ">
                    <h2>FAQ</h2>
                        <ul>
                            <li>
                                <h4><i></i>Sensoro Class: How does iBeacon realize positioning?</h4>
                                <!--<div>-->
                                    <!--There are lighting, acceleration and temperature sensors. Your smart phone can acquire various types of sensed data without manually connecting to BLE.-->
                                <!--</div>-->
                            </li>
                        </ul>
                </div>
            </div>

        </section>
    </div>
</template>

<script>
    export default {
        name: "question"
    }
</script>

<style lang="less">

    /*question页面*/
    .question-index {
        @baseWidth: 1360px;
        .center {
            width: @baseWidth;
            margin: 0 auto;
        }

        /*question 标题*/
        .question-title{
            margin: 183px auto 96px;
            font-size: 48px;
            color: #252525;
            line-height: 64px;
        }
        section{
            .know-more{
                display:flex;
                justify-content: space-between;
            }
            .develop,.FAQ{
                width: 660px;
                h2{
                    font-size: 28px;
                    color: #252525;
                    line-height: 42px;
                    margin-bottom: 24px;
                }
                ul{
                    li{
                        background: #FAFAFA;
                        padding-left: 24px;
                        padding-right: 24px;
                        margin-bottom: 16px;

                        i{
                            display: inline-block;
                            width: 8px;
                            height: 13px;
                            background: url("/static/image/question/closeClick@1x.png") no-repeat center;
                            margin-right: 16px;
                        }
                        h4{
                            font-size: 18px;
                            color: #252525;
                            height: 58px;
                            line-height: 58px;
                        }
                        div{
                            font-size: 18px;
                            color: #5D5D5D;
                            line-height: 26px;
                        }
                    }
                }
            }
            .develop{

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/question.vue